import { Fragment, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DismissIcon } from "../../../materials/icons/dismiss-icon/DismissIcon";
import { A } from "../../anchor/Anchor.Parts";
import { Body } from "../../body/Body";
import { IconButton } from "../../icon-button/IconButton.Parts";
import { InfoIcon } from "../icons/info-icon/InfoIcon";
import {
  Content,
  DescriptionContainer,
  DismissIconWrapper,
  IconBlock,
  ToastBlock,
  ToastMessageProps,
  alertIcons,
  toastIconMap,
} from "./ToastMessage.Parts";

export const ToastMessage = ({
  id,
  text,
  link,
  title,
  variant,
  removeToast,
  autoDismiss = true,
  dismissible = true,
}: ToastMessageProps) => {
  const [isDismissed, setIsDismissed] = useState(false);

  const dismiss = useCallback(() => {
    setIsDismissed(true);
    setTimeout(() => removeToast(id), 400);
  }, [removeToast, id]);

  useEffect(() => {
    if (!autoDismiss || autoDismiss === Infinity || variant === "error") return;
    const timer = setTimeout(
      dismiss,
      autoDismiss === true ? 3000 : autoDismiss,
    );
    return () => clearTimeout(timer);
  }, [removeToast, autoDismiss, variant, id, dismiss]);

  // Condition for showing dismiss button
  const showDismiss =
    dismissible ||
    !autoDismiss ||
    variant === "error" ||
    autoDismiss === Infinity;

  const Icon = (variant && toastIconMap[variant]) || InfoIcon;

  return (
    <ToastBlock $isDismissed={isDismissed}>
      <IconBlock $alert={alertIcons.has(variant || "")}>
        <Icon />
      </IconBlock>
      <Content>
        {title && (
          <Body tag="div" variant="normal-strong">
            {title}
          </Body>
        )}
        {(text || link) && (
          <DescriptionContainer>
            {text && (
              <Body tag="span" variant="small">
                {text?.split("\n").map((line, index, arr) => (
                  <Fragment key={index}>
                    {line}
                    {index < arr.length - 1 && <br />}
                  </Fragment>
                ))}
              </Body>
            )}
            {text && " "}
            {(link?.path || link?.href) && (
              <Body tag="span" variant="small">
                {link?.path && !link?.href && (
                  <Link to={link.path}>{link.text}</Link>
                )}
                {!link?.path && link?.href && (
                  /** @todo: Replace with <A> once designed */
                  <A href={link.href} target="_blank" rel="noopener noreferrer">
                    {link.text}
                  </A>
                )}
              </Body>
            )}
          </DescriptionContainer>
        )}
      </Content>
      {showDismiss && (
        <DismissIconWrapper>
          <IconButton onClick={dismiss}>
            <DismissIcon />
          </IconButton>
        </DismissIconWrapper>
      )}
    </ToastBlock>
  );
};
